import { render, staticRenderFns } from "./Svg.vue?vue&type=template&id=9203894c&scoped=true&"
import script from "./Svg.vue?vue&type=script&lang=js&"
export * from "./Svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9203894c",
  null
  
)

export default component.exports